<template>
  <GenericStep v-bind="$attrs">
    <HistoryOverviewCard class="mb-4" />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual, pick } from 'lodash'
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import HistoryOverviewCard from '@/components/Party/PartyEdit/SectionCards/OverviewCards/HistoryOverviewCard.vue'

export default {
  name: 'HistoryOverviewStep',

  components: {
    GenericStep,
    HistoryOverviewCard,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return pick(
        this.peParty, [
          'years_education',
          'any_work_history',
          'any_criminal_history',
          'previously_detained',
          'presently_detained',
        ]
      )
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },
}
</script>
